import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, Signal, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateDirective } from '@ngx-translate/core';
import { RouterBaseService } from '@tdwb/core';
import { InputGroupComponent } from '../../../components/form/input-group/input-group.component';
import { InputErrorsComponent } from '../../../components/form/input-errors/input-errors.component';
import { DividerComponent } from '../../../components/panel/divider.component';
import { FormRowComponent } from '../../../components/form/row/form-row.component';
import { ButtonComponent } from '../../../components/button/button.component';
import { HrefDirective } from '../../../directives/href/href.directive';
import { FormComponent } from '../../../components/form/form.component';
import { InputGroupFieldComponent } from '../../../components/form/input-group/input-group-field.component';
import { InputDirective } from '../../../components/input/input.directive';
import { InputGroupLabelComponent } from '../../../components/form/input-group/input-group-label.component';
import { W8BenFormErrorComponent } from '../w8ben-form-error/w8ben-form-error.component';
import { W8BenFormTooltipComponent } from '../w8ben-form-tooltip/w8ben-form-tooltip.component';
import { W8BenFormService } from '../w8ben-form.service';
import { W8BenFormAnalyticsService } from '../w8ben-form-analytics.service';
import { W8BenModalName } from '../w8ben-form.domain';
import { W8benFormAnalytics } from '../w8ben-form.analytics';

@Component({
  selector: 'td-wb-w8ben-form-us-tin',
  templateUrl: 'w8ben-form-us-tin.component.html',
  styleUrls: ['w8ben-form-us-tin.component.scss'],
  imports: [
    TranslateDirective,
    FormComponent,
    FormRowComponent,
    InputErrorsComponent,
    InputGroupComponent,
    InputGroupLabelComponent,
    InputGroupFieldComponent,
    W8BenFormTooltipComponent,
    InputDirective,
    DividerComponent,
    ButtonComponent,
    HrefDirective,
    FormsModule,
    W8BenFormErrorComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class W8BenFormUsTinComponent implements OnInit {
  @Input() hasUpdates: boolean = false;
  readonly form : Signal<FormComponent> = viewChild(FormComponent);

  protected submitError: boolean = false;
  protected tin: string | null = null;
  protected readonly allowableTinCharactersRegex: RegExp = W8BenFormService.TIN_REGEX;

  constructor(private routerService: RouterBaseService,
              private w8benFormService: W8BenFormService,
              private w8benFormAnalyticsService: W8BenFormAnalyticsService,
              private changeDetectionRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.w8benFormAnalyticsService.setTaggingData(W8BenModalName.US_TIN, 'a');
    this.w8benFormAnalyticsService.emitPageChange(W8benFormAnalytics.getModalEvent(W8BenModalName.US_TIN, 'a'));
    this.tin = this.w8benFormService.getIdentification('SSN');
  }

  protected getModalId(): string {
    return this.w8benFormAnalyticsService.getModalId();
  }

  protected continueDisabled(): boolean {
    return this.form()?.hasErrors() === true;
  }

  protected onClickBack(): void {
    this.w8benFormService.setIdentification('', 'SSN');
  }

  protected onClickContinue(): void {
    if (!this.form().hasErrors()) {
      this.w8benFormService.setIdentification(this.tin ?? '', 'SSN');
      this.w8benFormService.updateProfile(this.hasUpdates)?.subscribe({
        next: () => {
          this.routerService.go('modal.w8ben.review', { hasUpdates: this.hasUpdates });
        },
        error: (): void => {
          this.submitError = true;
          this.changeDetectionRef.markForCheck();
        },
        complete(): void {
        }
      });
    }
  }

  protected onClickTinInput(): void {
    this.w8benFormAnalyticsService.emitLinkClickEvent('w8ben:tin:update', false);
  }
}

